// src/components/user/ModuleAccessTab.jsx
import React from 'react';

function ModuleAccessTab({
  allModules = [],
  assignedModules = [],
  selectedModuleIds = [],
  setSelectedModuleIds,
  handleModuleAssign,
  handleModuleRemove
}) {
  return (
    <div className="row">
      <div className="col-md-5">
        <h6>All Modules</h6>
        <select
          className="form-select"
          multiple
          size="10"
          value={selectedModuleIds}
          onChange={(e) =>
            setSelectedModuleIds(Array.from(e.target.selectedOptions).map(opt => opt.value))
          }
        >
          {allModules.map(mod => (
            <option key={mod.id} value={mod.id}>
              {mod.module_name || mod.name}
            </option>
          ))}
        </select>
      </div>

      <div className="col-md-2 d-flex align-items-center justify-content-center">
        <button className="btn btn-primary" onClick={handleModuleAssign}>&gt;&gt;</button>
      </div>

      <div className="col-md-5">
        <h6>Assigned Modules</h6>
        <ul className="list-group">
          {assignedModules.map(mod => (
            <li key={mod.module_id || mod.id} className="list-group-item">
              {mod.module_name || mod.name}
              <button
                className="btn btn-sm btn-danger float-end"
                onClick={() => handleModuleRemove(mod.module_id || mod.id)}
              >
                &lt;&lt;
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default ModuleAccessTab;
